import { render, staticRenderFns } from "./Term_Quotation.vue?vue&type=template&id=195aa78e"
import script from "./Term_Quotation.vue?vue&type=script&lang=js"
export * from "./Term_Quotation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports